export default __webpack_public_path__ + "static/media/icaew_m2.c072b070.png";